import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'chameleon/ui-stack/ui/base/button';

const PopoverActionButton = ({ hasButtonMargin, actionLink, children }) => (
  <div
    className={classNames(`btn-popover-container`, {
      'buttons-margin': hasButtonMargin,
    })}
  >
    <Link to={actionLink}>
      <Button tabIndex={0} isPrimary accessibility={{ 'aria-label': 'View' }}>
        {children}
      </Button>
    </Link>
  </div>
);

PopoverActionButton.propTypes = {
  actionLink: PropTypes.string.isRequired,
  children: PropTypes.node,
  hasButtonMargin: PropTypes.bool,
};

PopoverActionButton.defaultProps = {
  hasButtonMargin: false,
  children: null,
};

export default PopoverActionButton;
